import { jsx as e, jsxs as g, Fragment as y } from "react/jsx-runtime";
import { Box as f, CircularProgress as S, Card as x, CardContent as C, Stack as Q, Skeleton as w, Typography as b, Button as U, Link as B } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import { calendars as E } from "../../queries/calendars/index.js";
import { w as T, O as M, k as q, o as H, z as G } from "../../index-DVHhaa_b.js";
import { student as $ } from "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import { assessment as P } from "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import { files as J } from "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import { courses as O } from "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { DiaryEntryType as I } from "../../helpers/daymaptypes.js";
import { DiaryItem as K } from "../list/components/events.js";
import { useAppState as W } from "../../context/app/index.js";
import { prettyDate as L } from "../../helpers/dates.js";
import { AttendanceMap as X } from "../attendance/AttendanceMap.js";
import { PdfViewer as ee } from "../pdf/index.js";
import { SanitizedHtml as te } from "../html/SanitizedHtml.js";
import { useState as ne } from "react";
function m({ label: i, value: o, onClick: s }) {
  return /* @__PURE__ */ g(Q, { alignItems: "flex-start", children: [
    /* @__PURE__ */ e(b, { variant: "caption", children: i }),
    s && o ? /* @__PURE__ */ e(B, { component: "button", variant: "body2", onClick: s, children: o }) : /* @__PURE__ */ e(b, { variant: "body2", children: o || "N/A" })
  ] });
}
function $e({ classId: i, studentId: o, year: s, current: p, onTeacherMessageClick: a, onNextAssessmentClick: n, onNextLessonClick: r, onOverdueAssessmentClick: c }) {
  const { data: l, isPending: d } = new $.ClassesByYear({ studentId: Number(o), year: s, current: p }).ToQuery(), t = l == null ? void 0 : l.find((F) => F.ClassID === Number(i)), { isPending: v, data: u } = new O.CourseByClassAndYear({ classId: i, year: s }).ToQuery(), { hasFeature: A } = M();
  return d || v ? /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: /* @__PURE__ */ g(Q, { spacing: 3, children: [
    /* @__PURE__ */ e(w, { variant: "rectangular", height: 40 }),
    /* @__PURE__ */ e(w, { variant: "rectangular", height: 40 }),
    /* @__PURE__ */ e(w, { variant: "rectangular", height: 40 })
  ] }) }) }) : t ? /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: /* @__PURE__ */ e(Q, { spacing: 3, children: /* @__PURE__ */ g(f, { children: [
    /* @__PURE__ */ g(f, { sx: {
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
      gap: 1
    }, children: [
      /* @__PURE__ */ g(f, { children: [
        /* @__PURE__ */ e(b, { variant: "caption", children: "Teacher" }),
        /* @__PURE__ */ e(f, { sx: { mt: 0.5, display: "flex", alignItems: "center", gap: 1 }, children: /* @__PURE__ */ e(q, { staffId: t.StaffID, contactId: t.Staff.ContactID, label: t.Staff.DisplaynameSurname, showMessageIconButton: !0, onContactMessageClick: a || void 0 }) })
      ] }),
      /* @__PURE__ */ e(m, { label: "Class name", value: t == null ? void 0 : t.ClassDisplayName }),
      /* @__PURE__ */ e(m, { label: "Subject", value: t == null ? void 0 : t.Subject }),
      /* @__PURE__ */ e(m, { label: "Year", value: s.toString() }),
      /* @__PURE__ */ e(m, { label: "Start", value: u != null && u.Start ? L(u.Start, { showDate: !0 }) : void 0 }),
      /* @__PURE__ */ e(m, { label: "End", value: u != null && u.Finish ? L(u.Finish, { showDate: !0 }) : void 0 }),
      u ? /* @__PURE__ */ e(
        se,
        {
          studentId: o,
          classId: i,
          from: u.Start,
          to: u.Finish,
          onClick: r
        }
      ) : /* @__PURE__ */ e(m, { label: "Next Lesson", value: "N/A" })
    ] }),
    /* @__PURE__ */ g(f, { sx: { mt: 2, display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }, children: [
      A(H.AssessmentPlus) && A(H.ParentPortal) && (p || s === (/* @__PURE__ */ new Date()).getFullYear()) && /* @__PURE__ */ g(f, { children: [
        /* @__PURE__ */ e(b, { variant: "caption", children: "Upcoming Assessment" }),
        /* @__PURE__ */ e(b, { variant: "body2", children: u && n ? /* @__PURE__ */ e(
          re,
          {
            studentId: o,
            courseId: u.CourseID,
            onClick: n
          }
        ) : "N/A" })
      ] }),
      A(H.AssessmentPlus) && (p || s === (/* @__PURE__ */ new Date()).getFullYear()) && u && c && /* @__PURE__ */ g(f, { children: [
        /* @__PURE__ */ e(b, { variant: "caption", children: "Assessment Alerts" }),
        /* @__PURE__ */ e(b, { variant: "body2", children: /* @__PURE__ */ e(
          oe,
          {
            studentId: o,
            courseId: u.CourseID,
            onClick: c
          }
        ) })
      ] })
    ] })
  ] }) }) }) }) : /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: /* @__PURE__ */ e(b, { color: "text.secondary", children: "Class not found." }) }) });
}
function Re({ classId: i, year: o, studentId: s, current: p }) {
  var c, l, d, t;
  const { isPending: a, data: n } = new $.getAttendanceRates({
    studentId: Number(s),
    classId: i,
    year: p ? 0 : o
  }).ToQuery();
  if (a)
    return /* @__PURE__ */ e(f, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }, children: /* @__PURE__ */ e(S, {}) });
  const r = Array.isArray(n) && n.length > 0 ? n[0] : null;
  return r ? /* @__PURE__ */ g(f, { children: [
    /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider", mb: 3 }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: /* @__PURE__ */ g(f, { sx: {
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
      gap: 3
    }, children: [
      /* @__PURE__ */ e(m, { label: "Total Lessons", value: (c = r.TotalCount) == null ? void 0 : c.toString() }),
      /* @__PURE__ */ e(m, { label: "Approved Absences", value: (l = r.ApprovedAbsentCount) == null ? void 0 : l.toString() }),
      /* @__PURE__ */ e(m, { label: "Approved %", value: r.ApprovedPercent !== void 0 ? `${r.ApprovedPercent}` : void 0 }),
      /* @__PURE__ */ e(m, { label: "Unapproved Absences", value: (d = r.UnapprovedAbsentCount) == null ? void 0 : d.toString() }),
      /* @__PURE__ */ e(m, { label: "Unapproved %", value: r.UnapprovedPercent !== void 0 ? `${r.UnapprovedPercent}` : void 0 }),
      /* @__PURE__ */ e(m, { label: "Cancelled Lessons", value: (t = r.CancelledCount) == null ? void 0 : t.toString() })
    ] }) }) }),
    /* @__PURE__ */ e(X, { studentId: Number(s), classId: i, reportYear: o, current: p })
  ] }) : /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: /* @__PURE__ */ e(T, { children: "No attendance data available for this class." }) }) });
}
function ze({ classId: i, studentId: o, year: s, onLessonClick: p, modalElement: a }) {
  const [n, r] = W(
    `ClassLessons_${i}`,
    { beforeCount: 0, afterCount: 10 },
    "session"
  ), { isPending: c, data: l } = new O.CourseByClassAndYear({ classId: i, year: s }).ToQuery();
  if (c || !l)
    return /* @__PURE__ */ e(f, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }, children: /* @__PURE__ */ e(S, {}) });
  const { isPending: d, data: t } = new E.DiaryItems({
    from: l.Start,
    to: l.Finish,
    studentId: Number(o),
    classId: i
  }).ToQuery();
  if (d)
    return /* @__PURE__ */ e(f, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }, children: /* @__PURE__ */ e(S, {}) });
  if (!t || t.length === 0)
    return /* @__PURE__ */ e(T, { children: "No lessons found for this class." });
  const v = t.filter((h) => h.Type === I.Lesson || h.Type === I.DailyOrganiserChange);
  if (v.length === 0)
    return /* @__PURE__ */ e(T, { children: "No lessons found for this class." });
  const u = /* @__PURE__ */ new Date(), F = Number(s) === u.getFullYear() ? new Date(u.setHours(0, 0, 0, 0)) : new Date(Number(s), u.getMonth(), u.getDate(), 0, 0, 0, 0), D = v.findIndex((h) => {
    const N = new Date(h.Start);
    return N.setHours(0, 0, 0, 0), N >= F;
  }), { beforeCount: k, afterCount: Y } = n;
  if (D === -1)
    return /* @__PURE__ */ e(T, { children: "There are no upcoming lessons for this class" });
  const R = Math.max(0, D - k), z = Math.min(v.length, D + Y), V = v.slice(R, z).sort((h, N) => h.Start.getTime() - N.Start.getTime()), Z = D > 0 && k < D, _ = D + Y < v.length, j = (h) => {
    r(
      h === "previous" ? { ...n, beforeCount: Math.min(k + 10, D) } : { ...n, afterCount: Y + 10 }
    );
  };
  return /* @__PURE__ */ g(y, { children: [
    a,
    /* @__PURE__ */ g(f, { sx: { display: "flex", flexFlow: "column", gap: 1 }, children: [
      Z && /* @__PURE__ */ e(U, { variant: "text", onClick: () => j("previous"), children: "Load Previous 10 Lessons" }),
      V.map((h) => /* @__PURE__ */ e(f, { children: /* @__PURE__ */ e(
        K,
        {
          hideStudentChip: !0,
          ...h,
          Title: Number(h.LessonNumber) > 0 ? "Lesson " + h.LessonNumber : h.Title,
          onClick: p
        }
      ) }, `${h.Type} ${h.ID}`)),
      _ && /* @__PURE__ */ e(U, { variant: "text", onClick: () => j("next"), children: "Load Next 10 Lessons" })
    ] })
  ] });
}
function re({ studentId: i, courseId: o, onClick: s }) {
  const { isPending: p, data: a } = new P.TasksForStudent({
    studentId: i,
    courseId: o,
    dateRange: P.AssessmentTaskListDateRange.Course,
    allPublished: !1
  }).ToQuery();
  if (p) return /* @__PURE__ */ e(w, { variant: "text", width: 150 });
  if (!a) return /* @__PURE__ */ e(y, { children: "N/A" });
  const n = /* @__PURE__ */ new Date();
  n.setHours(0, 0, 0, 0);
  const r = a.filter((d) => {
    const t = new Date(d.SetDate), v = new Date(d.DueDate);
    return t.setHours(0, 0, 0, 0), v.setHours(0, 0, 0, 0), t <= n && v >= n;
  });
  if (r.length === 0) return /* @__PURE__ */ e(y, { children: "N/A" });
  const c = r.sort(
    (d, t) => new Date(d.DueDate).getTime() - new Date(t.DueDate).getTime()
  )[0], l = L(c.DueDate, { showTime: !0, showDate: !0, showDay: !0 });
  return /* @__PURE__ */ e(
    B,
    {
      component: "button",
      variant: "body2",
      onClick: () => s(c.ID),
      children: l
    }
  );
}
function se({ studentId: i, classId: o, from: s, to: p, onClick: a }) {
  const { isPending: n, data: r } = new E.DiaryItems({
    from: s,
    to: p,
    studentId: i,
    classId: o
  }).ToQuery();
  if (n) return /* @__PURE__ */ e(w, { variant: "rectangular", height: 40 });
  if (!r) return /* @__PURE__ */ e(m, { label: "Next Lesson", value: "N/A" });
  const c = r.filter(
    (t) => t.Type === I.Lesson || t.Type === I.DailyOrganiserChange
  ), l = /* @__PURE__ */ new Date(), d = c.find((t) => new Date(t.Start) >= l);
  if (d)
    return /* @__PURE__ */ e(
      m,
      {
        label: "Next Lesson",
        value: L(d.Start, { showTime: !0, showDate: !0, showDay: !0 }),
        onClick: () => a && a(d)
      }
    );
  if (c.length > 0) {
    const t = c[c.length - 1];
    return /* @__PURE__ */ e(
      m,
      {
        label: "Last Lesson",
        value: L(t.Start, { showTime: !0, showDate: !0, showDay: !0 }),
        onClick: () => a && a(t)
      }
    );
  }
  return /* @__PURE__ */ e(m, { label: "Next Lesson", value: "N/A" });
}
function oe({ studentId: i, courseId: o, onClick: s }) {
  const { isPending: p, data: a } = new P.TasksForStudent({
    studentId: i,
    courseId: o,
    dateRange: P.AssessmentTaskListDateRange.Course,
    allPublished: !1
  }).ToQuery(), { hasTab: n } = M(), r = n(G.Assessment);
  if (p) return /* @__PURE__ */ e(w, { variant: "text", width: 150 });
  if (!a) return /* @__PURE__ */ e(y, { children: "No overdue assessment tasks" });
  const l = a.filter((t) => t.Overdue).length;
  if (l === 0) return /* @__PURE__ */ e(y, { children: "No overdue assessment tasks" });
  const d = `${l} assessment task${l !== 1 ? "s are" : " is"} overdue`;
  return r ? /* @__PURE__ */ e(
    B,
    {
      component: "button",
      variant: "body2",
      onClick: s,
      children: d
    }
  ) : /* @__PURE__ */ e(y, { children: d });
}
function Ve({ classId: i, year: o }) {
  const [s, p] = ne(null), { isPending: a, data: n } = new O.CourseByClassAndYear({ classId: i, year: o }).ToQuery(), r = !!(n != null && n.OutlineFileID && n.OutlineFileID !== 0), { data: c, isPending: l, error: d } = new J.FileBytes({
    FileId: (n == null ? void 0 : n.OutlineFileID) ?? 0,
    Pdf: !0,
    enable: !a && r,
    asBlob: !0
  }).ToQuery();
  return a || r && l ? /* @__PURE__ */ e(f, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }, children: /* @__PURE__ */ e(S, {}) }) : r ? d || !c || s ? /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: /* @__PURE__ */ e(T, { children: s ? "Unable to display the class outline PDF." : "Unable to load the class outline." }) }) }) : /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: /* @__PURE__ */ e(
    ee,
    {
      file: c,
      showZoomControls: !0,
      onLoadError: (t) => p(t)
    }
  ) }) }) : /* @__PURE__ */ e(x, { elevation: 1, sx: { border: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ e(C, { sx: { p: 3 }, children: n != null && n.Description ? /* @__PURE__ */ e(te, { html: n.Description, variant: "body1" }) : /* @__PURE__ */ e(T, { children: "No class outline available" }) }) });
}
export {
  Re as ClassAttendance,
  $e as ClassDetails,
  ze as ClassLessons,
  Ve as ClassOutline,
  re as NextAssessmentLink,
  se as NextLessonDisplay,
  oe as OverdueAssessmentCount
};
//# sourceMappingURL=ClassDetails.js.map
